import gql from 'graphql-tag';

export default gql`
  mutation UpsertCourseLearningVoice(
    $url: String!
    $title: String!
    $courseVersion: String!
    $courseId: String!
  ) {
    upsertCourseLearningVoice(
      url: $url
      title: $title
      courseVersion: $courseVersion
      courseId: $courseId
    ) {
      id
    }
  }
`;
